import { MutationTree } from 'vuex';
import { ErrorDetail } from '../../../types';
import { NodeOsAccountState } from './types';
import { Account } from '../../account/types';
import * as types from './mutation-types';
import { Node } from '../../node/types';

// OSアカウントの全てのエラーをクリアする
const resetAllErrors = (state: NodeOsAccountState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorCode = undefined;
    searchState.errorMsg = undefined;

    const directSearchState = state.directSearch;
    directSearchState.error = false;
    directSearchState.errorCode = undefined;
    directSearchState.errorMsg = undefined;

    const createState = state.create;
    createState.error = false;
    createState.errorTitle = undefined;
    createState.errorDetails = undefined;

    const showState = state.show;
    showState.error = false;
    showState.errorCode = undefined;
    showState.errorMsg = undefined;

    const updateState = state.update;
    updateState.error = false;
    updateState.errorTitle = undefined;
    updateState.errorDetails = undefined;

    const destroyState = state.destroy;
    destroyState.error = false;
    destroyState.errorTitle = undefined;
    destroyState.errorDetails = undefined;

    const connectionState = state.connection;
    connectionState.error = false;
    connectionState.errorTitle = undefined;
    connectionState.errorDetails = undefined;
};

export const mutations: MutationTree<NodeOsAccountState> = {
    // ノードOSアカウント一覧系
    [types.SEARCH_START](state) {
        resetAllErrors(state);
        const searchState = state.search;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; os_accounts: Array<Account> }) {
        state.osAccountCount = payload.count;
        state.osAccounts = payload.os_accounts;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // OSアカウント検索系（ノード内の検索）
    [types.DIRECT_SEARCH_START](state) {
        resetAllErrors(state);
        const directSearchState = state.directSearch;
        directSearchState.isProcessing = true;
        directSearchState.isFetchSuccess = false;
    },

    [types.DIRECT_SEARCH_SUCCESS](state, payload: { os_accounts: Array<Account> }) {
        state.wkOsAccountCount = payload.os_accounts.length;
        state.wkOsAccounts = payload.os_accounts;

        const directSearchState = state.directSearch;
        directSearchState.isProcessing = false;
        directSearchState.isFetchSuccess = true;
    },

    [types.DIRECT_SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const directSearchState = state.directSearch;
        directSearchState.errorCode = payload.code;
        directSearchState.errorMsg = payload.message;
        directSearchState.error = true;
        directSearchState.isProcessing = false;
        directSearchState.isFetchSuccess = false;
    },

    // OSアカウント追加系
    [types.NEW_ACCOUNTS](state) {
        resetAllErrors(state);
    },

    [types.CREATE_START](state) {
        resetAllErrors(state);
        const createState = state.create;
        createState.isProcessing = true;
    },

    [types.CREATE_SUCCESS](state) {
        const createState = state.create;
        createState.isProcessing = false;
    },

    [types.CREATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const createState = state.create;
        createState.errorTitle = payload.errorTitle;
        createState.errorDetails = payload.errorDetails;
        createState.error = true;
        createState.isProcessing = false;
    },

    // OSアカウント検索データクリア
    [types.CLEAR_WORK](state) {
        state.wkOsAccountCount = 0;
        state.wkOsAccounts = undefined;
    },

    // ノードOSアカウント詳細情報参照系
    [types.SHOW_START](state) {
        resetAllErrors(state);
        const showState = state.show;
        showState.error = false;
        showState.errorCode = undefined;
        showState.errorMsg = undefined;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](state, payload: { os_account: Account; node: Node }) {
        state.osAccountDetails.account = payload.os_account;
        state.osAccountDetails.node = payload.node;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // ノードOSアカウント更新系
    [types.UPDATE_START](state) {
        resetAllErrors(state);
        const updateState = state.update;
        updateState.isProcessing = true;
    },

    [types.UPDATE_SUCCESS](state) {
        const updateState = state.update;
        updateState.isProcessing = false;
    },

    [types.UPDATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const updateState = state.update;
        updateState.errorTitle = payload.errorTitle;
        updateState.errorDetails = payload.errorDetails;
        updateState.error = true;
        updateState.isProcessing = false;
    },

    // 接続テスト系
    [types.CONNECTION_START](state) {
        resetAllErrors(state);
        const connectionState = state.connection;
        connectionState.isProcessing = true;
    },

    [types.CONNECTION_SUCCESS](state) {
        const connectionState = state.connection;
        connectionState.isProcessing = false;
    },

    [types.CONNECTION_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const connectionState = state.connection;
        connectionState.errorTitle = payload.errorTitle;
        connectionState.errorDetails = payload.errorDetails;
        connectionState.error = true;
        connectionState.isProcessing = false;
    },

    // OSアカウント削減系
    [types.DESTROY_START](state) {
        resetAllErrors(state);
        const destroyState = state.destroy;
        destroyState.isProcessing = true;
    },

    [types.DESTROY_SUCCESS](state) {
        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.DESTROY_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const destroyState = state.destroy;
        destroyState.errorTitle = payload.errorTitle;
        destroyState.errorDetails = payload.errorDetails;
        destroyState.error = true;
        destroyState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const directSearchState = state.directSearch;
        directSearchState.isProcessing = false;
        directSearchState.isFetchSuccess = false;

        const createState = state.create;
        createState.isProcessing = false;

        const updateState = state.update;
        updateState.isProcessing = false;

        const destroyState = state.destroy;
        destroyState.isProcessing = false;

        const connectionState = state.connection;
        connectionState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetAllErrors(state);
        state.osAccounts = undefined;
        state.osAccountCount = 0;
        state.osAccountDetails.account = undefined;
        state.osAccountDetails.node = undefined;

        state.wkOsAccounts = undefined;
        state.wkOsAccountCount = 0;
    },
};
